import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import HTMLView from 'Components/HTMLView';
import { Box, ButtonFilled, Flex, SvgIcon, Text } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

import { TextTitle } from './AttachmentItem';

const AttachmentContent = ({ title, detail, backToAttachmentList }) => {
  const { t } = useTranslation('classroom');
  const { isMobile } = useCompatibleDisplay();

  return (
    <>
      <ButtonFilled
        color={'white'}
        mb={6}
        icon={SvgIcon.ICON_LIST.ARROW_LEFT}
        onClick={backToAttachmentList}
      >
        <Flex justifyContent={'center'} alignItems={'center'}>
          <SvgIcon mr={3} size={24} color={'text'} icon={SvgIcon.ICON_LIST.ARROW_LEFT} />
          <Text textStyle={'body1'} fontWeight={'bold'} color={'text'}>
            {t('BUTTON.BACK')}
          </Text>
        </Flex>
      </ButtonFilled>
      <Box
        backgroundColor={'white'}
        padding={6}
        style={{ borderRadius: 16, boxShadow: '0 2px 4px 0px rgba(0, 0, 0, 0.1)' }}
      >
        <TextTitle title={title} />
        <Text
          textStyle={isMobile ? 'body1' : 'subtitle1'}
          fontWeight={'normal'}
          mt={4}
          lineHeight={1.5}
        >
          <HTMLView rawContent={detail} />
        </Text>
      </Box>
    </>
  );
};

AttachmentContent.propTypes = {
  title: PropTypes.string,
  detail: PropTypes.string,
  backToAttachmentList: PropTypes.func,
};

export default AttachmentContent;
